import { Component, ViewChild, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { HierarchyDropdownItemModel } from 'shared/components/hierarchy-dropdown/models/hierarchy-dropdown-item.model';

@Component({
  selector: 'app-hierarchy-dropdown-sub-menu',
  templateUrl: './hierarchy-dropdown-sub-menu.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HierarchyDropdownSubMenuComponent<T> {
  @Input()
  items: T[];

  @Output()
  onSubItemSelected: EventEmitter<any> = new EventEmitter();

  @ViewChild('menuItem', {static: true}) menu: MatMenu;

  public selectedItem: HierarchyDropdownItemModel;

  onItemSelect(item: HierarchyDropdownItemModel): void {
    if (item.value === undefined) {
      return;
    }

    this.selectedItem = item;

    this.onSubItemSelected.emit(this.selectedItem);
  }
}
